import React from 'react';
import DashboardLayout from '@/layouts/DashboardLayout';
import { AvailabilityManager } from '@/components/calendar/AvailabilityManager';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const AvailabilityPage: React.FC = () => {
  return (
    <DashboardLayout>
      <div className="container max-w-6xl mx-auto px-4 py-8">
        <Card>
          <CardHeader>
            <CardTitle>Availability Settings</CardTitle>
            <CardDescription>
              Manage your working hours and availability preferences
            </CardDescription>
          </CardHeader>
          <CardContent>
            <AvailabilityManager />
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default AvailabilityPage; 